import React from 'react';
import useTranslation from 'utils/hooks/useTranslation';

import styles from './style.module.scss';

const AvailableBalance = ({
  balance = '£332.50',
  alertThreshold = '£10.00',
  status = 'active',
}) => {
  const { translateText } = useTranslation();

  return (
    <div className={styles.statCard} data-testid="walletAvailableBalance">
      <div className={styles.statHeader}>
        <span className={styles.statLabel}>
          {translateText('corporateAccounts.wallet.dashboard.availableBalance.label')}
        </span>
        <span className={styles.statChip}>
          {translateText(`corporateAccounts.common.status.${status}`)}
        </span>
      </div>
      <div className={styles.statValue}>{balance}</div>
      <div className={styles.statSub}>
        {translateText('corporateAccounts.wallet.dashboard.availableBalance.alertLine', {
          amount: alertThreshold,
        })}
      </div>
    </div>
  );
};

export default AvailableBalance;
